import { css } from '@inter-ikea-kompis/web-component';
import MiniPriceAlignmentEnum from '../../enums/MiniPriceAlignmentEnum.js';
export default class MiniPriceStyle {
    /**
     * Returns style.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @param options.align Alignment.
     * @param options.hasDualCurrencies ...
     * @param options.isTRO Time Restricted Offer.
     * @returns Css.
     */
    static getStyle(options) {
        const { color, spacing } = options.theme;
        return css `
			:host {
				display: flex;
				flex-direction: column;
				align-items: ${options.align === MiniPriceAlignmentEnum.right ? 'flex-end' : 'flex-start'};
				text-align: ${options.align === MiniPriceAlignmentEnum.right ? 'end' : 'start'};
			}

			.priceContainer {
				display: flex;
			}

			.innerPriceContainer {
				display: flex;
				justify-content: center;
				flex-direction: column;
				align-items: ${options.align === MiniPriceAlignmentEnum.right ? 'flex-end' : 'flex-start'};
			}

			.text {
				color: ${color.neutral.grey700};
			}

			.divider {
				display: flex;
				width: ${spacing.space50 / 16}rem;
				flex-shrink: 0;
			}

			.regularPriceTextDivider {
				display: flex;
				width: ${spacing.space25 / 16}rem;
				flex-shrink: 0;
			}

			skapa-commercial-message {
				font-size: ${14 / 16}rem;
			}

			.regularPrice {
				display: flex;
				justify-content: ${options.align === MiniPriceAlignmentEnum.right
            ? 'flex-end'
            : 'flex-start'};
			}

			.price {
				display: flex;
				color: ${color.text.dark};
				align-items: center;
			}

			.price:nth-child(odd) {
				margin-bottom: ${options.hasDualCurrencies ? 6 / 16 : 0}rem;
			}

			.price:nth-child(even):not(:last-child) {
				margin-bottom: ${options.isTRO ? 6 / 16 : 0}rem;
			}

			slot,
			kompis-eco-fee {
				pointer-events: auto;
				user-select: auto;
			}
		`;
    }
}
//# sourceMappingURL=MiniPriceStyle.js.map